<script lang="ts">
  import { _ } from 'svelte-i18n';
  // @ts-ignore
  import cashbackBanner from '../../assets/20260730_Abbildung Antragsseite CB Raeder & Reifen.png';
</script>

<div
  class="flex w-full max-w-[50rem] flex-1 flex-col space-y-4 pb-12 sm:space-y-6"
>
  <div class="mx-auto flex w-full max-w-[50rem] flex-col space-y-4">
    <!-- Top Image Container with text overlay -->
    <div class="relative w-full overflow-hidden rounded">
      <img
        class="h-auto w-full object-cover"
        src={cashbackBanner}
        alt="Mercedes-Benz Winterkomplettrad Cashback-Aktion 2026"
      />
      <div
        class="absolute inset-0 flex items-start justify-start bg-gradient-to-r from-black/80 via-black/40 to-transparent p-6 sm:p-8"
      >
        <p
          class="max-w-xs font-CorpoA text-2xl font-normal leading-tight text-white sm:max-w-sm sm:text-3xl md:text-4xl"
          style="white-space: pre-line;"
        >
          {$_(
            'The campaign period of the cashback campaign 2023 has not yet started.',
          )}
        </p>
      </div>
    </div>

    <div class="flex flex-col space-y-2 pr-4 pt-2">
      <p class="font-CorpoS text-sm text-[#333]">
        {$_('The registration period starts soon.')}
      </p>
      <h1
        class="font-CorpoA text-2xl font-normal leading-snug text-[#333] sm:text-3xl"
      >
        {$_(
          'Our cashback campaign for winter complete wheels has not yet started.',
        )}
      </h1>
    </div>

    <div>
      <div
        id="content"
        class="w-full max-w-[50rem] pr-4 font-CorpoS text-sm leading-relaxed text-[#767676] md:text-justify"
      >
        <div class="flex flex-col space-y-4">
          <p>
            {$_(
              'starting on ... you can register here for the cashback action.',
            )}
          </p>

          <p>
            {$_('Further information can be found in the new terms.')}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
